var uiBreakdown = {
	table: {
		caption: "Overzichten",
		weight: "Weging %",
		name: "Naam",
		noItems: "Geen resultaten gevonden"
	},
	chart: {
		counting: "Overzichten",
		topPositions: "Topposities",
		others: "Anderen"
	}
};
var nl = {
	uiBreakdown: uiBreakdown
};

export { nl as default, uiBreakdown };
